function toTimestamp(value) {
  if (!value) return null
  if (value instanceof Date) return value.getTime()
  const raw = String(value)
  const rawTimestamp = new Date(raw).getTime()
  const normalized = raw.replace(/-/g, '/')
  const timestamp = Number.isNaN(rawTimestamp) ? new Date(normalized).getTime() : rawTimestamp
  return Number.isNaN(timestamp) ? null : timestamp
}

/**
 * 返回当前活动报名时间状态：before、open、after。
 * 空的开始/截止时间表示不限制对应边界，兼容历史活动数据。
 */
export function getRegistrationStatus(registerStartTime, registerDeadline, now) {
  const current = now == null ? Date.now() : now
  const start = toTimestamp(registerStartTime)
  const deadline = toTimestamp(registerDeadline)
  if (start !== null && current < start) return 'before'
  if (deadline !== null && current > deadline) return 'after'
  return 'open'
}

export function getRegistrationMessage(status) {
  if (status === 'before') return '敬请期待'
  if (status === 'after') return '报名已结束，感谢关注。'
  return ''
}

export default {
  getRegistrationStatus,
  getRegistrationMessage
}
